import {
  listLocalWorkspaceMetasResolved,
  loadSnapshot,
} from '../services/localWorkspaceStore';

/**
 * Load all collections from every device-local workspace snapshot.
 * Used for the unified sidebar when viewing a cloud workspace.
 *
 * "Every" means every snapshot in the CURRENT ACCOUNT'S namespace:
 * listLocalWorkspaceMetasResolved / loadSnapshot build namespaced keys and
 * paths, so this cannot reach another account's snapshots even though it does
 * not check who owns anything.
 */
export async function loadAllDeviceLocalCollections() {
  const metas = await listLocalWorkspaceMetasResolved();
  if (!metas.length) return [];

  const results = await Promise.all(
    metas.map(async (meta) => {
      const snap = await loadSnapshot(meta.id);
      const wsName = meta.name || 'Local';
      return (snap.collections || []).map((c) => ({
        ...c,
        _deviceLocal: true,
        _localWorkspaceId: meta.id,
        _localWorkspaceName: wsName,
      }));
    })
  );

  return results.flat();
}
